export const BUY_HBAR_CLICK = "buy_hbar_click";
export const CONNECT_WALLET_CLICK = "connect_wallet_click";
export const WALLET_CONNECT_SUCCESS = "wallet_connect_success";
export const COPY_WALLET_ADDRESS = "copy_wallet_address";

export const DISCONNECT_WALLET_CLICK = "disconnect_wallet_click";

export const SELECTED_WALLET = "selected_wallet";

export const STAKE_CLICK = "stake_click";
export const STAKE_TRANSACTION_FAILED = "stake_transaction_failed";
export const STAKE_TRANSACTION_SUCCESS = "stake_transaction_success";
export const TRANSACTION_START = "transaction_start";

export const UNSTAKE_CLICK = "unstake_click";
export const UNSTAKE_TRANSACTION_FAILED = "unstake_transaction_failed";
export const UNSTAKE_TRANSACTION_SUCCESS = "unstake_transaction_success";

export const WITHDRAW_SUCCESS = "withdraw_success";
export const WITHDRAW_FAILED = "withdraw_failed";
export const WITHDRAW_CLICK = "withdraw_click";

export const HELP_CLICK = "help_click";
export const FAQ_CLICK = "faq_click";

export const TAB_CLICKED = "tab_clicked";

export const DEFI_SIDEBAR_CLICK = "defi_sidebar_click";
export const EXPLORE_DEFI_CLICK = "explore_defi_click";
export const HBARX_SIDEBAR_CLICK = "hbarx_sidebar_click";

export const THEME_CHANGE_CLICK = "theme_change_click";

export const STADER_LOGO_CLICKED = "stader_logo_clicked";

export const DEFI_CLICK = "defi_click";

export const EXPLORE_STAKING = "Explore_staking";
